import { activityHistory } from './activity-history'
import { auth } from './auth'
import { cariPetani } from './cari-petani'
import { cms } from './cms'
import { daftarGapoktan } from './daftar-gapoktan'
import { kep } from './daftar-kep'
import { daftarPetani } from './daftar-petani'
import { daftarPoktan } from './daftar-poktan'
import { dashboard } from './dashboard'
import { editPenyuluh } from './edit-penyuluh'
import { global } from './global'
import { guest } from './guest'
import { home } from './home'
import { penyuluhBpp } from './klb-penyuluh/bpp'
import { penyuluhDesa } from './klb-penyuluh/desa'
import * as penyuluhKotaKab from './klb-penyuluh/kotakab'
import { penyuluhProvinsi } from './klb-penyuluh/provinsi'
import { penyuluhPusat } from './klb-penyuluh/pusat'
import { apbnApbd } from './ktg-penyuluh/apbn-apbd'
import { pindahDomisili } from './ktg-penyuluh/pindah-domisili'
import { pnsPppk } from './ktg-penyuluh/pns-pppk'
import { swadaya } from './ktg-penyuluh/swadaya'
import { swasta } from './ktg-penyuluh/swasta'
import { monitoring } from './monitoring'
import { pengguna } from './pengguna'
import { administrator } from './pengguna/administrator'
import { adminKabupaten } from './pengguna/kabupaten'
import { adminKecamatan } from './pengguna/kecamatan'
import { adminProvince } from './pengguna/provinsi'
import { profile } from './profile'
import { referensi } from './references'
import { reportReference } from './report/reference'
import { verifikasi } from './verifikasi'
import { verifikasiWilkerPenyuluh } from './verifikasi-wilker-penyuluh'

export const api = {
  global,
  activityHistory,
  auth,
  profile,
  daftarPetani,
  daftarPoktan,
  daftarGapoktan,
  kep,
  home,
  cms,
  referensi,
  pnsPppk,
  pindahDomisili,
  swadaya,
  swasta,
  penyuluhDesa,
  cariPetani,
  penyuluhBpp,
  penyuluhKotaKab,
  apbnApbd,
  guest,
  penyuluhProvinsi,
  penyuluhPusat,
  pengguna,
  administrator,
  adminProvince,
  adminKabupaten,
  adminKecamatan,
  editPenyuluh,
  dashboard,
  reportReference,
  verifikasi,
  verifikasiWilkerPenyuluh,
  monitoring
}
